import { ChatMessageModel, ParticipantMessageModel } from '@klant/conversational-connector/models/ChatMessage.model';
import { ServiceAttachModel } from '@klant/conversational-connector/models/ServiceAttach.model';
import { AttachChannelModel } from '@klant/conversational-connector/models/AttachChannel.model';
import { StartConversationModel } from '@klant/conversational-connector/models/StartConversation.model';
import { ServiceDataModel } from '@klant/conversational-connector/models/ServiceData.model';

export interface SeamlyConfiguration {
    environment: string;
    seamlyApiKey: string;
    seamlyApiDomain: string;
    seamlyLocalVersion: number;
    locale: string;
}

export interface ChatSession {
    loginStatus: LoginStatus;
    token?: string;
}

export type PendingMessage = MessageModel | ActionModel;

export interface MessageModel {
    messageType: MessageType.MESSAGE;
    text: string;
    transactionId: string;
}

export interface ActionModel {
    messageType: MessageType.PICK_CHOICE_ACTION;
    originMessage: string;
    choiceOptionId: string;
    text: string;
    transactionId?: string;
}

export interface GroupedMessagesByTimestamp {
    date: Date;
    chatMessages: ChatMessageModel[];
}

export enum MessageType {
    MESSAGE = 'message',
    PICK_CHOICE_ACTION = 'pick-choice-action'
}

export const SeamlyAPIContext = {
    context: {
        contentLocale: 'nl-informal',
        channelName: 'api'
    }
};

export enum Platform {
    MIJN = 'mijn',
    MOBIEL = 'mobiel',
    RETAIL = 'retail'
}

export type WebsocketResponse =
    | AttachChannelModel
    | ParticipantMessageModel
    | ChatMessageModel
    | ServiceAttachModel
    | ServiceDataModel
    | StartConversationModel;

export enum ConversationalChatVisibility {
    OPEN = 'open',
    MINIMIZED = 'minimized',
    INVISIBLE = 'invisible'
}

export type ConversationalChatConnectionError = 'connection error' | 'retry connection error';

export enum LoginStatus {
    ANONYMOUS = 'anonymous',
    LOGGED_IN = 'logged-in'
}
